import {Component, OnDestroy, OnInit} from '@angular/core';
import {ForgetPasswordComponent} from "@app/channels/auth/login/partials/forget-password/forget-password.component";
import {ScreenManagerService} from "@mpt-fo/common/core/services/screen-manager.service";
import {SettingsService} from "@mpt-fo/common/core/services/settings.service";
import {OnboardingV2Service} from "@mpt-fo/common/core/services/onboarding-v2.service";
import {ModalService} from "@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service";
import {AppConfig} from "@mpt-fo/common/shared/config/app-config";
import {LoginHelperService} from "@mpt-fo/common/core/services/login-helper.service";
import {LocalStorageService} from "@mpt-fo/common/core/services/local-storage.service";
import {LivelinessService} from "@mpt-fo/common/core/services/liveliness.service";
import {AuthenticationService} from "@mpt-fo/common/core/services/authentication.service";
import {ProfileSetupService} from "@mpt-fo/common/core/services/profile-setup/profile-setup.service";
import { DataLayerService } from '@mpt-fo/common/core/services/data-layer-service.service';
import { DeviceHelperService } from '@mpt-fo/common/core/services/device-helper.service';
import { LocationHelper } from '@mpt-fo/common/core/helpers/location.helper';

@Component({
  selector: 'app-mobile-forget-password',
  templateUrl: './mobile-forget-password.component.html',
  styleUrls: ['./mobile-forget-password.component.scss']
})
export class MobileForgetPasswordComponent extends ForgetPasswordComponent implements OnInit{

  constructor(
      screenManagerService: ScreenManagerService,
      settingsService: SettingsService,
      public modalHelper: OnboardingV2Service,
      modalService: ModalService,
      public config: AppConfig,
      loginHelper: LoginHelperService,
      localStorage: LocalStorageService,
	  livelinessService: LivelinessService,
	  authService: AuthenticationService,
	  profileService: ProfileSetupService,
		deviceHelper: DeviceHelperService,
    dataLayerService: DataLayerService, locationHelper: LocationHelper) {
     super(screenManagerService, settingsService,
		modalHelper, modalService, config,
		loginHelper, localStorage, livelinessService, authService, profileService,deviceHelper,dataLayerService, locationHelper);
  }

  ngOnInit(): void {
    this.initialize();
  }

  handlePasscodeResponse(message: string){
    if(this.runningModal){this.runningModal.destroy();}
    this.SuccessDescription = message ?? this.SuccessDescription;
    this.setCurrentStep(this.RecoveryStep.PASSWORD_UPDATED);
  }

}
